module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"input_ds:empty":"Не выбран"},"en":{"input_ds:empty":"Not selected"}}')
  delete Component.options._Ctor
}
